import React, { useState, useEffect, useCallback } from 'react';
import HeaderDesktop from './HeaderDesktop';
import style from './block.module.scss';
// image
import linkedin_icon_url from './ico-linkedin.svg';
import twitter_icon_url from './ico-twitter.svg';
import facebook_icon_url from './ico-facebook.svg';
import logo_url from './logo-white.svg';
import logo_sticky_url from './logo-color.svg';
import useMedia from 'use-media';
import clsx from 'clsx';

function Block({ menu, custom_settings, isHome, hideMenu }) {
    const { linkedin, twitter, facebook, demo } = custom_settings;
    const [isOpen, setOpen] = useState(false);
    const [isScrollUp, setScrollUp] = useState(false);
    const isTablet = useMedia({ maxWidth: style.contentWidth });
    const isMobile = useMedia({ maxWidth: style.mobileBreakpoint });
    useEffect(() => {
        let scrollY = 0;

        window.addEventListener('scroll', () => {
            scrollY = window.pageYOffset || document.documentElement.scrollTop;
            setScrollUp(scrollY > 60);
        });
    }, []);

    const handleClick = useCallback(() => {
        if (document && document.body && document.body.style) {
            document.body.style.overflow = isOpen ? 'auto' : 'hidden';
            setOpen(!isOpen);
        }
    }, [isOpen, setOpen]);

    return (
        <div className={style.block}>
            <div className={clsx(style.header, (!isHome || isScrollUp) && style.page, isScrollUp && style.sticky)}>
                {isTablet ? (
                    <>
                        {!hideMenu && (
                            <button
                                type="button"
                                className={clsx(
                                    style.menuButton,
                                    ((isHome && !isScrollUp) || isOpen) && style.menuButtonHome,
                                    isOpen && style.menuClose,
                                )}
                                onClick={handleClick}
                            >
                                <span></span>
                                <span></span>
                                <span></span>
                                <p className="sr-only">{isOpen ? 'Fermer le menu' : 'Ouvrir le menu'}</p>
                            </button>
                        )}

                        <div className={clsx(!hideMenu && style.menu, isOpen && style.menuOpen)}>
                            <div>
                                {!hideMenu &&
                                    menu &&
                                    Object.values(menu).map((key) => (
                                        <div>
                                            <a href={key.url} className={style.mainLink}>
                                                {key.title}
                                            </a>
                                            {key.children && (
                                                <ul className={style.children}>
                                                    {key.children.map((child) => (
                                                        <li>
                                                            <a href={child.url}>{child.title}</a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        </div>

                        {isHome && !isScrollUp && (
                            <img src={logo_url} alt="Logo cadeaux privés" className={style.logo} />
                        )}

                        {(isScrollUp || !isHome) && (
                            <a href="/" className={style.logo}>
                                <img src={logo_sticky_url} alt="Logo cadeaux privés" />
                            </a>
                        )}
                    </>
                ) : (
                    <HeaderDesktop menu={menu} isHomeMenuTop={isHome && !isScrollUp} hideMenu={hideMenu} />
                )}

                {/* Import button here */}
                <div>
                    {demo && !isMobile && (
                        <a
                            href={demo}
                            type="button"
                            className={`${style.button} ${(isScrollUp || !isHome) && style.buttonRed}`}
                            id={hideMenu ? 'contact-head-landing-page' : null}
                        >
                            Contactez-nous
                        </a>
                    )}
                </div>
            </div>

            {isHome && (
                <ul className={style.social}>
                    {twitter && (
                        <li>
                            <a href={twitter} target="_blank" rel="noopener noreferrer">
                                <img src={twitter_icon_url} alt="Twitter" />
                            </a>
                        </li>
                    )}
                    {facebook && (
                        <li>
                            <a href={facebook} target="_blank" rel="noopener noreferrer">
                                <img src={facebook_icon_url} alt="facebook" />
                            </a>
                        </li>
                    )}
                    {linkedin && (
                        <li>
                            <a href={linkedin} target="_blank" rel="noopener noreferrer">
                                <img src={linkedin_icon_url} alt="linkedin" />
                            </a>
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
}

export default Block;
